import React from 'react';
import {useLocation} from 'react-router-dom';
import {
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react-pro';

const PrivateBreadcrumb = () => {

  const currentLocation = useLocation();

  const formatBreadcrumb = (path) => {
    var splits = path.split('/');
    var title = splits[splits.length - 1];
    splits = title.split('-');
    var formattedTitle = '';
    splits.forEach(split => {
      if (formattedTitle.length > 0) {
        formattedTitle += ' ';
      }
      formattedTitle += split.charAt(0).toUpperCase() + split.slice(1);
    });
    return formattedTitle;
  }

  return (
    <CBreadcrumb className='m-0 ms-2'>
      <CBreadcrumbItem active={true}>
        {formatBreadcrumb(currentLocation.pathname)}
      </CBreadcrumbItem>
    </CBreadcrumb>
  );
}

export default React.memo(PrivateBreadcrumb);
